module.exports = __webpack_public_path__ + "static/openclaw-why-700e7982e3c5c827962823721009e720.jpg";